export const objectsAreDifferents = (objectA?: any, objectB?: any) =>
  JSON.stringify(objectA) !== JSON.stringify(objectB);
